import type { UrlUnfurledData } from 'core_main/pubnub/types';

/**
 * Title / price lines for URL preview when chat-api sends optional `unfurledUrl.structuredData`.
 * Co-located in widget: `import/no-restricted-paths` disallows importing core helpers from widget code.
 *
 * **Fallback order (widget)**
 * 1. If `structuredData` is missing or not a non-null object: use legacy `title` (trimmed); no price.
 * 2. If `structuredData` is present: use non-empty trimmed `structuredData.title` for the headline,
 *    or if empty, fall back to legacy `title` (so price-only structured payloads still show a title).
 *    Price line uses non-empty trimmed `structuredData.price`.
 */
export function getUnfurledPreviewTitleDisplay(preview: UrlUnfurledData): {
  titleText: string | undefined;
  priceText: string | undefined;
} {
  const d = preview.structuredData;
  if (d != null && typeof d === 'object') {
    const fromStructuredData =
      typeof d.title === 'string' && d.title.trim() !== ''
        ? d.title.trim()
        : '';
    const price =
      typeof d.price === 'string' && d.price.trim() !== ''
        ? d.price.trim()
        : '';
    const legacyTitle = preview.title?.trim();
    return {
      titleText: fromStructuredData || legacyTitle || undefined,
      priceText: price || undefined,
    };
  }
  const legacyTitle = preview.title?.trim();
  return {
    titleText: legacyTitle || undefined,
    priceText: undefined,
  };
}
